import { combineReducers } from 'redux';
import { reducerAdmin, reducerCommon, reducerDoctor, reducerLoader, reducerCache, reducerPatient } from './reducers';

const rootReducer = combineReducers({
    admin: reducerAdmin,
    cache: reducerCache,
    common: reducerCommon,
    doctor: reducerDoctor,
    loader: reducerLoader,
    patient: reducerPatient,
});

export default rootReducer;